import { forwardRef } from 'react'
import cn from 'clsx'
import type { TImageProps } from './Image.types'
import styles from './Image.module.css'

export const Image = forwardRef<HTMLImageElement, TImageProps>(
    ({ className, fill = false, alt = '', ...props }, ref) => (
        <img ref={ref} alt={alt} className={cn({ [styles.fill]: fill }, className)} {...props} />
    ),
)
